module.exports = __webpack_public_path__ + "img/usa.bdfbb855.svg";